export default {
  props: {
    variant: {
      type: String,
      default: null
    },
    flat: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultClass: 'text-gray-700 bg-gray-300 hover:bg-gray-400',
      infoClass: 'text-white bg-blue-600 border-blue-400 hover:bg-blue-700',
      successClass: 'text-white bg-green-500 border-green-400 hover:bg-green-700',
      dangerClass: 'text-white bg-red-500 border-red-500 hover:bg-red-600 hover:border-red-600',
      warningClass: 'text-white bg-yellow-500 border-yellow-500 hover:bg-yellow-600 hover:border-yellow-600',
      lightClass: 'text-white bg-gray-200 hover:bg-gray-300 hover:text-gray-700',
      darkClass: 'text-white bg-gray-700 hover:bg-gray-700',
      primaryClass: 'text-white bg-primary hover:bg-opacity-85',
      secondaryClass: 'text-white bg-secondary hover:bg-opacity-85',

      defaultFlatClass: 'text-gray-600 bg-gray-200 hover:bg-gray-300 hover:text-gray-700',
      infoFlatClass: 'bg-blue-200 text-blue-700 hover:bg-blue-600 hover:text-white',
      successFlatClass: 'bg-green-100 text-green-700 hover:bg-green-600 hover:text-white',
      dangerFlatClass: 'bg-red-200 text-red-700 hover:bg-red-600 hover:text-white',
      warningFlatClass: 'bg-yellow-100 text-yellow-700 hover:bg-yellow-600 hover:text-white',
      lightFlatClass: 'bg-gray-200 text-gray-700 hover:bg-gray-300 hover:text-gray-700',
      darkFlatClass: 'bg-gray-200 text-gray-700 hover:bg-gray-600 hover:text-white',

      defaultOutlineClass: 'border border-gray-400 text-gray-600',
      infoOutlineClass: 'border border-blue-400 text-blue-600',
      successOutlineClass: 'border border-green-400 text-green-600',
      dangerOutlineClass: 'border border-red-400 text-red-600',
      warningOutlineClass: 'border border-yellow-400 text-yellow-500',
      lightOutlineClass: 'border border-gray-100 text-gray-100',
      darkOutlineClass: 'border border-gray-800 text-gray-800'
    }
  },
  methods: {
    variants (classes) {
      if (!this.flat && !this.outline) {
        switch (this.variant) {
          case 'info':
            classes.push(this.infoClass)
            break
          case 'danger':
            classes.push(this.dangerClass)
            break
          case 'warning':
            classes.push(this.warningClass)
            break
          case 'success':
            classes.push(this.successClass)
            break
          case 'light':
            classes.push(this.lightClass)
            break
          case 'dark':
            classes.push(this.darkClass)
            break
          case 'primary':
            classes.push(this.primaryClass)
            break
          case 'secondary':
            classes.push(this.secondaryClass)
            break
          default:
            classes.push(this.defaultClass)
            break
        }
      }
      if (this.flat) {
        switch (this.variant) {
          case 'info':
            classes.push(this.infoFlatClass)
            break
          case 'danger':
            classes.push(this.dangerFlatClass)
            break
          case 'warning':
            classes.push(this.warningFlatClass)
            break
          case 'success':
            classes.push(this.successFlatClass)
            break
          case 'light':
            classes.push(this.lightFlatClass)
            break
          case 'dark':
            classes.push(this.darkFlatClass)
            break
          default:
            classes.push(this.defaultFlatClass)
            break
        }
      }
      if (this.outline) {
        switch (this.variant) {
          case 'info':
            classes.push(this.infoOutlineClass)
            break
          case 'danger':
            classes.push(this.dangerOutlineClass)
            break
          case 'warning':
            classes.push(this.warningOutlineClass)
            break
          case 'success':
            classes.push(this.successOutlineClass)
            break
          case 'light':
            classes.push(this.lightOutlineClass)
            break
          case 'dark':
            classes.push(this.darkOutlineClass)
            break
          default:
            classes.push(this.defaultOutlineClass)
            break
        }
      }
      return classes
    }
  }
}
